import {Injectable} from "@angular/core";
import {TotalPackageData} from "@models/total-package-data.interface";

@Injectable()
export class PackageDetailsService {
  getTotalPackagesData(packages, isDividable = true): TotalPackageData {
    return {
      quantity: packages.reduce((total, {quantity = 0}) => total + +quantity, 0),
      volume: packages.reduce(
        (total, {height, width, length, quantity}) => height && width && length && quantity ?
          (total + (+height * +width * +length) * +quantity / (isDividable ? 1000000 : 1))
          : total,
        0
      ).toFixed(2),
      weight: packages.reduce(
        (total, {weight, quantity}) => weight && quantity ? (total + +weight * +quantity) : total,
        0
      ),
      type: packages[0].type,
      stackable: packages[0].stackable,
      stackableText: ''
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/package-details.service.ts